import { createFileRoute } from "@tanstack/react-router";
import { protectedRoute } from "@/lib/protectedRoute";
import { Templates } from "@/pages/Templates";

export const Route = createFileRoute("/templates")({
  component: Templates,
  beforeLoad: () => {
    return protectedRoute({ location: window.location });
  },
});
